import { toast } from 'react-toastify';

const enum ToastType {
    INFO = 'info',
    SUCCESS = 'success',
    WARNING = 'warning',
    ERROR = 'error',
    DEFAULT = 'default'
}

const defaultOptions = {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: 5000,
    hideProgressBar: true,
    newestOnTop: false,
    closeOnClick: true,
    rtl: false,
    pauseOnVisibilityChange: true,
    draggable: true,
    pauseOnHover: true,
    theme: 'colored'
};

export default class Toast {
    public static notify = (message: string, type: ToastType) => {
        const options = { ...defaultOptions, type: type };
        toast(message, options as any);
    };

    public static notifyInfo = (message: string) => {
        Toast.notify(message, ToastType.INFO);
    };

    public static notifySuccess = (message: string) => {
        Toast.notify(message, ToastType.SUCCESS);
    };

    public static notifyWarninng = (message: string) => {
        Toast.notify(message, ToastType.WARNING);
    };

    public static notifyError = (message: string) => {
        Toast.notify(message, ToastType.ERROR);
    };

    public static notifyErrors = (messages: string[]) => {

        for (var i = 0; i < messages.length; i++) {
            Toast.notify(messages[i], ToastType.ERROR);
        }
    }

    public static notifyDefault = (message: string) => {
        Toast.notify(message, ToastType.DEFAULT);
    };
}